import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { TimelineItem, TimelineProps } from "./Timeline.d";

export const TimelinePart = (props: ComponentProps<PartData>) => {
  const {
    title,
    subtitle,
    timelineItems = [],
  } = (props.data as TimelineProps) ?? {};

  if (!timelineItems.length) return <p>Add some items!</p>;

  return (
    <div className="container">
      <section className="timeline">
      {(title || subtitle) && (
        <div className="timeline__header">
          {title && <h3 className="timeline__title">{title}</h3>}
          {subtitle && <p className="timeline__subtitle">{subtitle}</p>}
        </div>
      )}

      <ol className="timeline__list">
        {timelineItems.map((item: TimelineItem, idx: number) => {
          const isCompleted = item.completed ?? false;
          const isLast = idx === timelineItems.length - 1;

          return (
            <li
              key={idx}
              className={[
                "timeline__item",
                isCompleted ? "timeline__item--completed" : "",
                isCompleted ? "timeline__item--checkmark" : "",
                isLast ? "timeline__item--last" : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <div className="timeline__dot-col">
                <div
                  className="timeline__dot"
                  aria-label={`${item.itemTitle} — ${isCompleted ? "fullført" : "ikke fullført"}`}
                  role="img"
                >
                  {isCompleted && (
                    <svg
                      className="timeline__dot-check"
                      viewBox="0 0 12 12"
                      aria-hidden="true"
                    >
                      <polyline
                        points="2,6 5,9 10,3"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
                {!isLast && <div className="timeline__connector" />}
              </div>

              <div className="timeline__content">
                {item.date && (
                  <span className="timeline__date">{item.date}</span>
                )}
                <strong className="timeline__item-title">{item.itemTitle}</strong>
                {item.itemSubtitle && (
                  <span className="timeline__item-subtitle">
                    {item.itemSubtitle}
                  </span>
                )}
                {item.linkUrl && (
                  <a
                    href={item.linkUrl}
                    className="timeline__item-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.linkLabel || item.linkUrl}
                  </a>
                )}
              </div>
            </li>
          );
        })}
      </ol>
      </section>
    </div>
  );
};

export default TimelinePart;